import {
	CircleCheck,
	Info,
	LoaderCircle,
	OctagonX,
	TriangleAlert,
} from 'lucide-react'
import { Toaster as Sonner } from 'sonner'
import { type Theme } from '#app/utils/theme.server.ts'

type ToasterProps = React.ComponentProps<typeof Sonner> & {
	theme?: Theme
}

const Toaster = ({ theme = 'light', ...props }: ToasterProps) => {
	return (
		<Sonner
			theme={theme as ToasterProps['theme']}
			className="toaster group"
			icons={{
				success: <CircleCheck className="h-4 w-4" />,
				info: <Info className="h-4 w-4" />,
				warning: <TriangleAlert className="h-4 w-4" />,
				error: <OctagonX className="h-4 w-4" />,
				loading: <LoaderCircle className="h-4 w-4 animate-spin" />,
			}}
			toastOptions={{
				classNames: {
					toast:
						'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
					description: 'group-[.toast]:text-muted-foreground',
					actionButton:
						'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
					cancelButton:
						'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
				},
			}}
			{...props}
		/>
	)
}

// Export both Toaster and EpicToaster for backward compatibility
export { Toaster, Toaster as EpicToaster }
